import React from 'react';
import './PayfazzLogin.css';

import Loading from './Loading';

class PayfazzLogin extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      eye: false
    }
  }

  componentDidMount(){
    this.refs.loginUser.focus()
  }

  hangleViewPassword = (e) => {
    let password = this.refs.loginPassword;
    if (password.type === 'password') {
      password.type = 'text';
    } else {
      password.type = 'password';
    }
    this.setState({eye: !this.state.eye});
  }

  render() {
    const {
      title,
      desc,
      loading,
      errorMsg,
      onSubmit,
      valueInput,
      valuePassword,
      onChangeInput,
      onChangePassword } = this.props;

    let msgError = '';
    if (errorMsg !== '') {
      msgError = <div className="login__message">{errorMsg}</div>
    }

    return (
      <div className="login">
        <div className="login__inner">
          <h2 className="login__title">{title}</h2>
          <div className="login__text">{desc}</div>

          {
            loading ? <Loading/>
            :
              <form className="login__form" onSubmit={onSubmit}>
                <input
                  type="text"
                  ref="loginUser"
                  name="username"
                  placeholder="Username or email"
                  value={valueInput}
                  onChange={onChangeInput}
                />
                <div className={this.state.eye ? 'password-with-icon on' : 'password-with-icon'}>
                  <input
                    type="password"
                    name="password"
                    ref="loginPassword"
                    placeholder="Password"
                    value={valuePassword}
                    onChange={onChangePassword}
                  />
                  <img src="https://cdn0.iconfinder.com/data/icons/feather/96/eye-16.png" alt="View" title="View" onClick={this.hangleViewPassword}/>
                </div>
                <button type="submit" className="login__button">LOGIN</button>
                {msgError}
              </form>
          }
        </div>
      </div>
    );
  }
}

PayfazzLogin.defaultProps = {
  title: 'LOGIN',
  desc: 'Please Enter Your Information',
  loading: false
};

export default PayfazzLogin;



// WEBPACK FOOTER //
// ./src/app/module/PayfazzLogin.js